import React from "react";
import { Card } from "antd";
import { useForgotPasswordContext } from "context/ForgotPasswordEnumeratorContext";
import { useLocation } from "react-router-dom";
import PasswordOtpReuqest from "./components/RequestOtp";
import PasswordOtpVerify from "./components/VerifyOtp";
import PasswordSetup from "./components/PasswordSetup";

const ChangePassword: React.FC = () => {
  const [email, setEmail] = React.useState<string>("");
  const [code, setCode] = React.useState<string>("");

  const { isEmailSent, isCodeVerified, isFirstStep } = useForgotPasswordContext();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryValue = queryParams.get("roleType");

  return (
    <React.Fragment>
      <div className="h-screen bg-background overflow-auto">
        <div className="max-w-lg mx-auto mt-12 px-5 md:px-0 ">
          <Card className="px-4 py-6">
            {isFirstStep && <PasswordOtpReuqest setEmail={setEmail} roleType={queryValue} />}
            {isEmailSent && (
              <PasswordOtpVerify email={email} setCode={setCode} roleType={queryValue} />
            )}
            {isCodeVerified && <PasswordSetup email={email} code={code} roleType={queryValue} />}
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ChangePassword;
